





























































































































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';
import HelpContainerSlide from '@/core/msw-app-content/components/help-container-slide.vue';
import { Mutation } from 'vuex-class';
import { SetHelpContentIdPayload, InfoState } from '@/core/core.store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import  { MswApiService } from '@/shared/msw-api-service';
import { SwMessageContainer }  from '@libs-uuif/shared/message-service';
import { ApiError } from '@libs-uuif/shared/api-service';
import { confirmService, ConfirmOptions, ConfirmButton } from '@libs-uuif/shared/confirm-service';
import { helpContentData } from '@/shared/help-content-data/msw-help-data';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import MswAffiliationsTab from '@/modules/msw-products/components/msw-user-group/affiliations-tab.vue';
import * as decode from 'jwt-decode';
import { CreateElement, VNode } from 'vue';
import { currentUserKey } from '@/shared/msw-constants';
import { SwTabGroup, SwTabPage, TabProps } from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import Userlist from '../../../msw-profile/components/userlist.vue';
import OrgUserList from '../../../msw-profile/components/orgUserList.vue';
import ListUserGroups from './list-user-groups.vue';
import UserGroupExtension from './user-group-extension.vue';
import CreateUser from './create-user.vue';
import { AddUserToUserGroupBodyType, DeleteUserDataType, UserGroupAPIResponse } from '../../types';
import AssignTenantsModal from './assign-tenants-modal.vue';

const cssPrefix = 'user-group-tab';

@Component({
  components: {
    CreateUser,
    UserGroupExtension,
    ListUserGroups,
    HelpContainerSlide,
    SwIcon,
    SwModal,
    SwModalBody,
    SwMessageContainer,
    SwScrollView,
    SwTabGroup,
    SwTabPage,
    Userlist,
    OrgUserList,
    MswAffiliationsTab,
    AssignTenantsModal,
  },
})

export default class MswUserGroupsTab extends SwExtendedVue {
  cssPrefix = cssPrefix;

  selectedTabId: string = 'tab1';
  basicTabsProps: TabProps[] = [
    { tabId: 'tab1', label: this.$t('userGroups.userGroups')
      .toString(),
    },
  ];
  userGroupHelpFlag: boolean = true;
  showExtension: boolean = false;
  selectedExtensionTab : string = 'user-groups-users-tab';
  createUserModal: boolean = false;
  helplink:string = '';
  enableHelpContainer: boolean = true;
  options: ConfirmOptions;
  buttons: ConfirmButton[];
  scrollUserGroupToTop : boolean = false;
  showUserGroupList: boolean = false;
  triggerUserGroupsAndUsersForUserGroupApi: boolean = false;
  showCreateUserGrplink: boolean = false;
  addUserGroup: boolean = false;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  get isOrgBased() {
    const currentUser: any = localStorage.getItem(currentUserKey);
    const token: any = decode(JSON.parse(currentUser)?.token || '');
    return token?.orgbased === 'YES';
  }

  get userGroups() {
    return this.$store.getters['MswUserGroupStoreModule/getUserGroups'] || [];
  }

  get userGroupsCount() {
    return this.userGroups?.length || 0;
  }

  get selectedUserGroupDetail() {
    return this.$store.getters['MswUserGroupStoreModule/getSelectedUserGroupDetail'] || [];
  }

  get selectedUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getSelectedUserGroup'] || [];
  }

  get showNewUserGroupBtn() {
    return this.defaultProductGroupId !== '' && this.showCreateUserGrplink;
  }

  get defaultProductGroupId() {
    return this.$store.getters['MswUserGroupStoreModule/getDefaultProductGroupId'];
  }

  get defaultUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getDefaultUserGroup'] || '';
  }

  get usersForUserGroup() {
    return this.$store.getters['MswUserGroupStoreModule/getUsersForUserGroup'] || '';
  }

  get assignedUsersForUserGroup() {
    return this.usersForUserGroup?.assignedusers || [];
  }

  get showAssignTenantModal() {
    return this.$store.getters['MswUserGroupStoreModule/getShowAssignTenantModal'];
  }

  set showAssignTenantModal(value: boolean) {
    this.$store.commit('MswUserGroupStoreModule/setShowAssignTenantModal', value);
  }

  checkHelpFlag(flagName: string, extendUserGroup: boolean) {
    this.showExtension = extendUserGroup ? true : false;
    window.parent.postMessage({
      showHelp : this.showExtension,
    },                        '*');
    this.selectedExtensionTab = flagName;
    if (flagName === 'user-groups-help') {
      this.selectedExtensionTab = 'user-groups-users-tab';
    }
    switch (flagName) {
      case 'user-groups-help':
        this.initializeHelpFlag();
        this.userGroupHelpFlag = true;
        this.enableHelpContainer = true;
        break;
      case 'user-groups-customer-tab':
        this.initializeHelpFlag();
        this.enableHelpContainer = false;
        break;
      case 'user-groups-users-tab':
        this.initializeHelpFlag();
        this.enableHelpContainer = false;
        break;
      case 'user-groups-permission-tab':
        this.initializeHelpFlag();
        this.enableHelpContainer = false;
        break;
      case 'user-group-create-help':
        this.initializeHelpFlag();
        this.enableHelpContainer = false;
      default:
        this.initializeHelpFlag();
        this.userGroupHelpFlag = true;
        this.enableHelpContainer = true;
        break;
    }
    helpContentData.forEach((node) => {
      if (node.helpId === flagName) {
        this.helplink = node.content;
      }
    });
    this.setHelpId(flagName);
  }

  initializeHelpFlag () {
    this.userGroupHelpFlag = false;
  }

  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }

  onSelectTab(tabId: string) {
    this.selectedTabId = tabId;
    window.parent.postMessage({ showHelp : false }, '*');
    if (this.selectedTabId === 'tab1') {
      this.showExtension = false;
      this.enableHelpContainer = true;
      helpContentData.forEach((node: any) => {
        if (node.helpId === 'user-groups-help') {
          this.helplink = node.content;
        }
      });
    }
    if (this.selectedTabId === 'tab2') {
      this.$store.commit('AccessManagementStoreModule/setTriggerUserGroupApi', false);
    }

  }

  groupExtension(open = false) {
    this.showExtension = open ? true : this.showExtension;
  }

  onAssignCustomer() {
    this.createUserModal = false;
  }

  showCreateUserModal() {
    this.createUserModal = true;
  }

  hideCreateUserModal() {
    this.createUserModal = false;
  }

  inviteUser(inviteUserPayload: any) {
    if (this.selectedUserGroupDetail[0]?.isDefaultGroup?.toLowerCase() === 'true' && inviteUserPayload?.contactTypeId === '10015' && !this.isOrgBased) {
      const message :InfoState = { infoMsg : 'You cannot add user of Reseller / Customer to the default user group since it would give admin access to all the tenants.' , infoType : 'failed' };
      this.$store.commit('enqueueMessage', message);
      return;
    }
    const email = JSON.parse(localStorage.getItem(currentUserKey) as any)?.email;
    if (email && email.split('@')[1] !== inviteUserPayload?.emailAddress?.split('@')[1] && inviteUserPayload?.contactTypeId === '10001' && this.selectedUserGroupDetail[0]?.isDefaultGroup?.toLowerCase() === 'true') {
      this.buttons = [
        { key: 'cancel', name: 'Cancel', isDefault: true },
        { key: 'yes', name: 'Yes' },
      ];
      this.options = {
        status: 'high',
        title: 'Confirmation',
        message: 'Adding a user to default user group would give admin access to all the tenants. Are you sure you want to add to default user group ?',
        buttons: this.buttons,
      };
      confirmService.confirm(this.options).then((key) => {
        if (key === 'yes') {
          this.inviteUsers(inviteUserPayload, false);
        }
      });
    } else {
      this.inviteUsers(inviteUserPayload, false);
    }
  }

  inviteUsers(data: any, booleanValue?: any) {
    this.triggerUserGroupsAndUsersForUserGroupApi = false;
    this.$store.commit('startLoading');
    MswApiService.createCustomer.addUsers(data, booleanValue)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp?.msgCode === 'MSWAPP:ADDUSERWARNING') {
        this.confirmAdd(data, resp.msgDesc);
      } else if (resp?.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp?.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        this.hideCreateUserModal();
        this.$store.commit('displayMessage', { infoType: 'success', infoMsg: resp?.msgDesc });
        this.triggerUserGroupsAndUsersForUserGroupApi = true;
      }
    });
  }

  confirmAdd(data: any, resp: any) {
    this.buttons = [
      { key: 'cancel', name: 'Cancel', isDefault: true },
      { key: 'yes', name: 'Yes' },
    ];
    this.options = {
      status: 'high',
      title: 'Confirmation',
      message: resp,
      buttons: this.buttons,
    };
    confirmService.confirm(this.options).then((key) => {
      if (key === 'yes') {
        this.$store.commit('startLoading');
        MswApiService.createCustomer.addUsers(data, true)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.msgCode === 'MSWAPP:ADDUSERWARNING') {
            this.confirmAdd(data, res.msgDesc);
          }
          if (res.operationStatus === 'NOK') {
            this.$store.commit('displayMessage', { infoType: 'high', infoMsg: resp?.msgDesc });
          } else {
            this.hideCreateUserModal();
            this.$store.commit('displayMessage', { infoType: 'success', infoMsg: resp?.msgDesc });
            this.triggerUserGroupsAndUsersForUserGroupApi = true;
          }
        });
      }
    });
  }

  addedUsersToUserGroup(usersToAdd: any) {
    const usersTobeAdded: AddUserToUserGroupBodyType = {
      bsendMail: null,
      contactLists: [...usersToAdd],
    };
    this.triggerUserGroupsAndUsersForUserGroupApi = false;
    this.$store.commit('startLoading');
    MswApiService.createCustomer.manageUsers(usersTobeAdded).then((resp: UserGroupAPIResponse) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'NOK') {
        this.$store.commit('displayMessage', { infoType: 'high', infoMsg: resp?.msgDesc });
      } else {
        this.hideCreateUserModal();
        this.$store.commit('displayMessage', { infoType: 'success', infoMsg: resp?.msgDesc });
        this.triggerUserGroupsAndUsersForUserGroupApi = true;
      }
    });
  }

  removeUserFromUserGroup(selectedUser: any) {
    const usersTobeDeleted: DeleteUserDataType = {
      bsendMail: null,
      contactLists: [
        {
          partyGroupId: selectedUser?.partyGroupId || '',
          partyId: selectedUser?.partyId || '',
          action: 'delete',
        },
      ],
    };
    this.triggerUserGroupsAndUsersForUserGroupApi = false;
    this.$store.commit('startLoading');
    MswApiService.createCustomer.manageUsers(usersTobeDeleted)
    .then((resp: UserGroupAPIResponse) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'NOK') {
        this.$store.commit('displayMessage', { infoType: 'high', infoMsg: resp?.msgDesc });
      } else {
        this.$store.commit('displayMessage', { infoType: 'success', infoMsg: resp?.msgDesc });
        this.triggerUserGroupsAndUsersForUserGroupApi = true;
      }
    });
  }

  handleDeleteUserGroup() {
    this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
    const { partyGroupId = '' } = this.selectedUserGroupDetail[0] || {};
    const userGroupDataToBeDeleted = {
      bsendMail: false,
      userGroupList: [{ partyGroupId }],
    };
    this.$store.commit('startLoading');
    MswApiService.createCustomer.deleteUserGroup(userGroupDataToBeDeleted)
    .then((resp: any) => {
      if (resp?.msgCode !== 'MSWAPP:DELTEUSERGROUPSUCCESS') {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        this.loadUserGroups()
        .finally(() => {
          this.$store.commit('stopLoading');
          this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
          this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
          this.$store.commit('MswUserGroupStoreModule/setSelectedUserGroupDetail', []);
        });
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    })
    .catch((error: ApiError) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: error?.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }

  onMakeDefault(partyGroupId: string) {
    this.scrollUserGroupToTop = false;
    const { partyGroupName: defaultUserGroupName = '' } = this.defaultUserGroup || {};
    const { partyGroupName: selectedUserGroupName = '', partyGroupId: selectedUserGroupId = '' } = this.selectedUserGroupDetail[0] || {};
    this.buttons = [
      { key: 'cancel', name: 'Cancel', isDefault: true },
      { key: 'yes', name: 'Yes' },
    ];
    this.options = {
      status: 'informational',
      title: 'Confirmation',
      // tslint:disable-next-line:no-unused
      message : (h: CreateElement): VNode => {
        return h('div', {
          // tslint:disable-next-line:max-line-length
          domProps: { innerHTML: defaultUserGroupName ?
          // tslint:disable-next-line:max-line-length
          `Setting the default group would give admin access to all the users of that group to all the tenants. Are you sure you want to change the default user group from <b>${defaultUserGroupName}</b> to <b>${selectedUserGroupName}</b> ?` :
          // tslint:disable-next-line:max-line-length
          `Setting the default group would give admin access to all the users of that group to all the tenants. Are you sure you want to change the default user group to <b>${selectedUserGroupName}</b> ?` },
        });
      },
      buttons: this.buttons,
    };
    confirmService.confirm(this.options)
    .then((key) => {
      if (key === 'yes') {
        this.$store.commit('startLoading');
        MswApiService.createCustomer.manageDefaultGroup({ GroupId: partyGroupId, Mode: 'USER' })
        .then((resp: any) => {
          if (resp.operationStatus === 'NOK') {
            this.$store.commit('stopLoading');
            const message: InfoState = { infoType: 'high', infoMsg: resp?.msgDesc };
            this.$store.commit('displayMessage', message);
          } else {
            this.scrollUserGroupToTop = true;
            // this.showExtension = false;
            this.loadUserGroups()
            .finally(() => {
              this.$store.commit('stopLoading');
              if (this.selectedUserGroup?.length > 0) {
                this.$store.commit('MswUserGroupStoreModule/setSelectedUserGroupDetail', this.selectedUserGroupDetail[0]);
                this.$store.commit('MswUserGroupStoreModule/userGroupSelected', [selectedUserGroupId]);
              }
            });
            const message: InfoState = { infoType: 'success', infoMsg: resp?.msgDesc };
            this.$store.commit('displayMessage', message);
          }
        })
        .catch((error: ApiError) => {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'high', infoMsg: error?.message || 'Unknown Error' };
          this.$store.commit('displayMessage', message);
        });
      }
    });
  }

  handleAddUserGroup(userGroupName: string) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.createUserGrp(userGroupName, this.defaultProductGroupId)
    .then((resp: any) => {
      if (resp.operationStatus === 'NOK') {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        this.loadUserGroups()
        .then(() => {
          this.$store.commit('stopLoading');
          const selectedUserGroup: any = this.userGroups?.filter((ele: any) => ele?.partyGroupName === userGroupName)[0] || '';
          this.$store.commit('MswUserGroupStoreModule/setSelectedUserGroupDetail', [selectedUserGroup]);
          this.$store.commit('MswUserGroupStoreModule/userGroupSelected', [selectedUserGroup?.partyGroupId]);
          this.selectedExtensionTab = 'user-groups-users-tab';
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        })
        .catch(() => {
          this.$store.commit('stopLoading');
        });
      }
    })
    .catch((error: ApiError) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: error.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }

  handleUpdateUserGroup(userGroupName: string) {
    const dataToBeEdited = {
      partyGroupId: this.selectedUserGroupDetail[0]?.partyGroupId || '',
      newPartyGroupName: userGroupName,
      bSendMail: false,
    };
    this.$store.commit('startLoading');
    MswApiService.createCustomer.editUserGroup(dataToBeEdited)
    .then((resp: any) => {
      if (resp?.operationStatus === 'NOK') {
        this.$store.commit('stopLoading');
        this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
        this.showExtension = false;
        window.parent.postMessage({
          showHelp : this.showExtension,
        },                        '*');
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        this.loadUserGroups()
        .then(() => {
          this.$store.commit('stopLoading');
          if (this.selectedUserGroup?.length > 0) {
            this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', [dataToBeEdited?.partyGroupId]);
          }
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        })
        .catch(() => {
          this.$store.commit('stopLoading');
        });
      }
    })
    .catch((error: ApiError) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: error?.message || 'Unknown Error' };
      this.$store.commit('displayMessage', message);
    });
  }

  addUpdateUserGroup(userGroupName: string, addUserGroup: boolean) {
    this.scrollUserGroupToTop = false;
    if (addUserGroup) {
      this.handleAddUserGroup(userGroupName);
    } else {
      this.handleUpdateUserGroup(userGroupName);
    }
  }

  loadUserGroups() {
    return new Promise((resolve, reject) => {
      this.$store.commit('startLoading');
      MswApiService.userGroup.listUserGroups()
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        this.showCreateUserGrplink = resp?.showCreateUserGrplink === 'true';
        this.$store.commit('MswUserGroupStoreModule/setDefaultProductGroupId', resp?.defaultTenantId);
        this.$store.commit('MswUserGroupStoreModule/setUserGroups', resp?.userGroups || []);
        this.$store.commit('MswUserGroupStoreModule/setAffiliateGroups', resp?.affiliateGroups || []);
        resolve(true);
      })
      .catch((error: ApiError) => {
        this.$store.commit('stopLoading');
        reject(true);
        this.$store.commit('displayMessage', { infoType: 'high', infoMsg: error?.message });
      })
      .finally(() => {
        this.showUserGroupList = true;
      });
    });
  }

  created() {
    this.setHelpId('users-tab-user-groups');
    this.loadUserGroups();
  }

  mounted() {
    this.setHelpId('users-tab-user-groups');
    helpContentData.forEach((node) => {
      if (node.helpId === 'user-groups-help') {
        this.helplink = node.content;
      }
    });
    const currentUser: any = localStorage.getItem(currentUserKey);
    const token: any = decode(JSON.parse(currentUser)?.token || '');
    if (token.hasOwnProperty('orgbased') && token?.orgbased === 'YES') {
      this.basicTabsProps.push(
        {
          tabId: 'tab2',
          /* tslint:disable-next-line */
          label: (h: CreateElement): VNode => {
            return (
              <div style="display:flex;align-items:center;">
                <span style="margin-right:1rem;"> { this.$t('profile.affiliations') } </span>
                <div style="cursor:pointer;">
                  {/* tslint:disable-next-line */}
                  <SwIcon name="informational" props-size={15} v-tooltip={{ content: this.$t('affiliation.add.affliationTT'), compact: true, placement: 'bottom' }} ></SwIcon>
                </div>
              </div>
            ) as VNode;
          },
        },
      );
    }
    this.basicTabsProps.push(
      {
        tabId: 'tab3',
        label: this.$t('profile.users')
        .toString(),
      },
    );
  }
}
